
import React, { useEffect, useState, useRef } from "react";
import { FormText } from "reactstrap";
import { Trans } from "react-i18next";
import { getBase64 } from "services/util";
import { NotificationManager } from "react-notifications";

export const InputFile = ({ file, setData, innerRef, InputName="attachment", custom=false }) => {

    const [attachment, setAttachment] = useState("");
    const [attachmentName, setAttachmentName] = useState("skip");

    const handleFileInputChange = e => {
        const file = e.target.files[0];
        getBase64(file)
            .then(result => {
                file["base64"] = result;
                setAttachment(result)
                setAttachmentName(file.name)
            })
            .catch(err => {
            });
    };


    function getName(file_dic) {
        const file = file_dic?.file ? file_dic?.file : file_dic?.attachment ? file_dic?.attachment : file_dic?.attachment?.file
        const file_name = file_dic?.name ? file_dic?.name : file_dic?.attachment?.name
        if (file){
            if((file_name || file_dic.name) && (file_name !=="skip" || file_dic.name !=="skip")){
                return file_name || file_dic?.name
            }
            const file_path = file
            if (file_path && (typeof (file_path) == "string") && file_path.includes(".")) {
                const path_array = file_path.split('/')
                const content = path_array[path_array.length - 1]
                return content
            }
        }
        return null
    }

    function getFileName(file_dic) {
        const name = getName(file_dic)
        
        const file = file_dic?.file ? file_dic?.file : file_dic?.attachment?.file?.file?.file === undefined ? "" : file_dic?.attachment?.file ? file_dic?.attachment?.file :  file_dic?.attachment?.file === undefined ? "" : file_dic?.attachment;
        
        if(name && !file.includes('data:application')){
            const content = (<span>{name}<i className="fas fa-arrow-circle-down mx-2"></i></span>)
            return (<a className="mx-1 link text-success" href={file} target="_blank">{content}</a>)
        }
        return (<span><Trans>No Current File Yet</Trans></span>)
    }

    useEffect(() => {
        if(custom)
            setData({ name: attachmentName, file: attachment })
        else
            setData((data) => {return { ...data, [InputName]: { name: attachmentName, file: attachment } }})
    }, [attachment, attachmentName]);


    useEffect(() => {
        if(custom)
            setData({ name: 'skip', file: file.file || file.attachment })
        else
            setData((data) => ({ ...data, [InputName]: { name: 'skip', file: file.file || file.attachment } }))
    }, []);

    return (
        <>
            {
                <div>
                    <div className="input-group input-group-lg"> 
                        <div className="custom-file">
                            <input name={InputName} type="file" className="custom-file-input" onChange={(handleFileInputChange)} ref={innerRef}/>
                            <label className="custom-file-label" htmlFor="customFileInput" style={{overflow:"hidden"}}>{getName(file)? getName(file):<span><Trans>Select File</Trans></span>}</label>
                        </div>
                        <div className="input-group-append">
                            <button className="btn btn-default custom" type="button" id="uploadBtn" onClick={()=>{setAttachment(null); setAttachmentName("")}}><Trans>Clear</Trans></button>
                        </div>
                    </div>
                    <FormText>
                            <span className="mx-1"><Trans>Current file</Trans></span> : {getFileName(file)}
                    </FormText>
                </div>
            }
        </>)

};

export default InputFile;